import { Div, Image, Text } from "atomize"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import AuthModal from "../modals/AuthModal"
import { PHONE_HEADER_HEIGHT, PHONE_HEADER_TOP, PHONE_ISLAND_SIDE } from "../atoms/phoneBars"

// L'accesso dell'app: quello che vede chi apre una pagina dell'app senza
// essere dentro — l'app installata appena scaricata, la sessione scaduta,
// dopo "Esci dall'account". Prima ci si trovava sul sito, con il foglio
// dell'accesso aperto sopra; ora sito e app sono due cose, e qui si resta
// nell'app: la fascia arancione è la sua, il modulo è lo stesso del sito.
//
// Il sito è a un tocco, in fondo, per chi l'app non sa ancora cos'è.
function Access() {
	return (
		<Div minH="100vh" bg="background" d="flex" flexDir="column">
			{/* la fascia delle lezioni, con solo il marchio: la stessa isola,
			    alla stessa altezza, così entrando non salta niente */}
			<Div
				bg="primary"
				shadow={theme.shadows.accent}
				d="flex"
				align="center"
				justify="center"
				style={{
					margin: `${PHONE_HEADER_TOP} ${PHONE_ISLAND_SIDE} 0`,
					borderRadius: "1.875rem",
					boxSizing: "border-box",
					height: PHONE_HEADER_HEIGHT,
				}}>
				<Image
					src={require("../images/incampo_logo_header.png")}
					alt="inCampo"
					h="1.5rem"
					w="auto"
				/>
			</Div>

			<Div
				w="100%"
				maxW="30rem"
				m={{ x: "auto" }}
				p={{ x: "0.5rem", t: "1.5rem" }}
				flexGrow="1"
				d="flex"
				flexDir="column"
				style={{ boxSizing: "border-box" }}>
				<Div
					bg="surface"
					rounded="20px"
					shadow={theme.shadows.accent}
					p={{ t: "1.25rem", b: "1.5rem", x: "0.5rem" }}>
					<AuthModal inCard />
				</Div>

				<Div
					m={{ t: "auto" }}
					p={{ t: "2rem", b: "calc(1.5rem + env(safe-area-inset-bottom))" }}
					textAlign="center">
					<Link
						to="/"
						style={{
							display: "inline-flex",
							alignItems: "center",
							gap: "0.4rem",
							minHeight: "2.75rem",
							textDecoration: "none",
						}}>
						<Text tag="span" textSize="caption" textWeight="500" textColor="gunmetal">
							Cos'è inCampo? Guarda il sito
						</Text>
						<FontAwesomeIcon icon={faArrowRight} size="xs" color={theme.colors.text_light} />
					</Link>
				</Div>
			</Div>
		</Div>
	)
}

export default Access
